// src/utils/authUtils.ts
import { supabase } from '../lib/supabaseClient';
import { debugLog } from './debugLog';

export class AuthUtils {
  /**
   * Tüm auth verilerini temizler - Kapsamlı reset
   */
  static async clearAllAuthData(): Promise<void> {
    try {
      // Custom auth kontrolü - koruması
      const customToken = localStorage.getItem('custom_auth_token');
      if (customToken) {
        debugLog('[authUtils] custom auth koruması - clearAllAuthData atlandı');
        return;
      }
      
      debugLog('[authUtils] tüm auth verileri temizleniyor...');
      
      // 1. Supabase auth session'ını temizle
      await supabase.auth.signOut();
      
      // 2. LocalStorage temizle
      const authKeys = [
        'sb-auth-token',
        'supabase.auth.token',
        'rememberMe',
        'rememberedEmail',
        'lastActivity'
      ];
      
      authKeys.forEach(key => {
        localStorage.removeItem(key);
      });
      
      // 3. SessionStorage temizle
      sessionStorage.clear();
      
      // 4. Supabase client'ı reset et
      await supabase.auth.refreshSession();
      
      debugLog('[authUtils] auth verileri temizlendi');
      
    } catch (error) {
      console.error('❌ Auth temizleme hatası:', error);
    }
  }

  /**
   * Session durumunu kontrol eder - Custom auth ve Supabase auth'u destekler
   */
  static async validateSession(): Promise<boolean> {
    try {
      // Custom auth token kontrol et
      const customToken = localStorage.getItem('custom_auth_token');
      if (customToken) {
        debugLog('[authUtils] custom auth session geçerli');
        return true;
      }
      
      // Supabase auth session kontrol et
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (error) {
        console.error('Session validation error:', error);
        return false;
      }
      
      return !!session;
    } catch (error) {
      console.error('Session check error:', error);
      return false;
    }
  }

  /**
   * Debug bilgileri
   */
  static async debugAuthState(): Promise<void> {
    console.group('🔍 Auth Debug Info');
    
    try {
      const { data: { session } } = await supabase.auth.getSession();
      debugLog('[authUtils] session', session);
      
      const authToken = localStorage.getItem('sb-auth-token');
      debugLog('[authUtils] localStorage auth token', authToken);
      
      const rememberMe = localStorage.getItem('rememberMe');
      debugLog('[authUtils] remember me', rememberMe);
      
    } catch (error) {
      console.error('Debug error:', error);
    }
    
    console.groupEnd();
  }

  /**
   * Zorla logout - Tüm verileri temizle ve login'e yönlendir
   */
  static async forceLogout(): Promise<void> {
    await this.clearAllAuthData();
    window.location.href = '/auth/login';
  }
}
